// src/data/servicesSeoData.js
// Authoritative SEO data and content repository for WiYou! Tech Studios

export const SERVICES_SEO_MAP = {
  "web-development": {
    slugId: "web-development",
    title: "Custom Website Development",
    seoTitle: "Web Development Company in Jaipur | Custom Websites | WiYou! Tech Studios",
    metaDescription: "WiYou! Tech Studios is a leading web development company in Jaipur crafting fast, responsive, and custom business websites engineered for modern performance and SEO.",
    primaryKeyword: "web development company in Jaipur",
    secondaryKeywords: [
      "website development company Jaipur",
      "web development agency Jaipur",
      "custom web development India",
      "business website development",
      "responsive website development",
    ],
    category: "Engineering",
    badge: "Core Service",
    h1: "Web Development Company in Jaipur for High-Performance Businesses",
    subtitle: "Turnkey full-stack architectures, custom responsive websites, and scalable digital platforms built with precision engineering.",
    imageUrl: "/assets/projects/1.jpeg",
    overview:
      "At WiYou! Tech Studios, we design and build bespoke business websites that stand out in crowded digital landscapes. As an established web development agency in Jaipur, Rajasthan, we don't rely on cookie-cutter page builders. We architect clean, semantic React, Next.js, and modern full-stack web solutions that achieve sub-second load times, flawless responsiveness on every screen, and built-in technical SEO that helps businesses earn organic visibility across Jaipur and throughout India.",
    deliverables: [
      "Custom responsive layouts optimized for mobile, tablet, and desktop",
      "Sub-second Core Web Vitals and performance optimization",
      "Semantic HTML5, clean architecture, and technical SEO structure",
      "Content Management System (CMS) integrations for effortless content updates",
      "Secure hosting, custom domain configuration, and SSL deployment",
      "Continuous website monitoring, backups, and maintenance plans",
    ],
    features: [
      {
        title: "Architecture & Clean Code",
        description: "Zero bloat. Built with modern component-driven architectures ensuring lightning-fast execution and effortless maintainability.",
      },
      {
        title: "Search Engine Optimization Built-In",
        description: "Engineered from the ground up with schema markup, canonicalization, optimized metadata, and fast mobile rendering.",
      },
      {
        title: "End-to-End Delivery",
        description: "From initial information architecture and wireframing through to final deployment, custom DNS configuration, and launch.",
      },
    ],
    faqs: [
      {
        question: "What does a website development company in Jaipur do?",
        answer: "A professional web development company like WiYou! Tech Studios handles the end-to-end design, technical architecture, coding, database integration, SEO foundation, and deployment of modern business websites and web applications.",
      },
      {
        question: "How long does it take to build a custom business website?",
        answer: "Typical custom business websites take between 2 to 4 weeks depending on the number of pages, custom features, and integration requirements. We provide transparent timelines before starting any project.",
      },
      {
        question: "Do you build websites for businesses outside Jaipur?",
        answer: "Yes. While we are proudly headquartered in Jaipur, Rajasthan, we regularly engineer digital platforms for startups, hospitality groups, and enterprises across India and internationally.",
      },
    ],
  },

  "web-design": {
    slugId: "web-design",
    title: "UI/UX & Web Design",
    seoTitle: "Web Design Company in Jaipur | UI UX Design Agency | WiYou! Tech Studios",
    metaDescription: "WiYou! Tech Studios is a premier web design agency in Jaipur crafting editorial digital interfaces, bespoke design systems, and conversion-led UI/UX experiences.",
    primaryKeyword: "web design company Jaipur",
    secondaryKeywords: [
      "web design agency in Jaipur",
      "website design company Jaipur",
      "UI UX design Jaipur",
      "custom website design",
      "modern web design services",
    ],
    category: "Design Architecture",
    badge: "UI/UX Design",
    h1: "Web Design Company in Jaipur Creating Human-Centered Digital Experiences",
    subtitle: "Art-directed digital interfaces that elevate brand authority with bespoke design tokens, fluid motion, and intuitive user journeys.",
    imageUrl: "/assets/projects/2.jpeg",
    overview:
      "Exceptional design is not merely decoration—it is clarity, trust, and effortless utility. As a dedicated web design company in Jaipur, WiYou! Tech Studios combines editorial visual aesthetics with rigorous user experience principles. We craft custom design systems, responsive wireframes, and high-fidelity interactive prototypes that guide visitors smoothly toward conversion while expressing your brand's unique identity.",
    deliverables: [
      "Bespoke design systems with consistent typography, color scales, and tokens",
      "High-fidelity interactive prototypes in Figma for rapid feedback and iteration",
      "Mobile-first responsive layouts tested across modern devices and resolutions",
      "Micro-animations and kinetic interactions that enhance user engagement",
      "Accessibility (a11y) audits ensuring high contrast and readable hierarchy",
    ],
    features: [
      {
        title: "Art-Directed Visuals",
        description: "Custom editorial aesthetics tailored to your sector—moving away from generic templates to build authentic brand equity.",
      },
      {
        title: "Conversion-Focused UX",
        description: "Intuitive navigation flows, prominent action triggers, and friction-free user paths designed to drive inquiries and sales.",
      },
      {
        title: "Design-to-Code Precision",
        description: "Pixel-perfect translation from Figma design systems into clean, responsive HTML, CSS, and modern React components.",
      },
    ],
    faqs: [
      {
        question: "Can you redesign our existing company website?",
        answer: "Yes. We frequently conduct complete digital redesigns—modernizing your visual brand, restructuring information architecture, and boosting mobile usability without losing your search rankings.",
      },
      {
        question: "Do you provide Figma files and design assets?",
        answer: "Absolutely. All clients receive full ownership of their Figma source files, design component libraries, vector assets, and typography guidelines upon project completion.",
      },
    ],
  },

  "qr-menu-design": {
    slugId: "qr-menu-design",
    title: "QR Menu Design",
    seoTitle: "QR Menu Design in Jaipur for Restaurants & Cafés | WiYou! Tech Studios",
    metaDescription: "Professional QR menu design in Jaipur by WiYou! Tech Studios. Custom, mobile-friendly QR code menus for restaurants, cafés, and hotels across Rajasthan & India.",
    primaryKeyword: "QR menu design Jaipur",
    secondaryKeywords: [
      "restaurant QR menu design",
      "QR code menu design Jaipur",
      "digital QR menu design",
      "custom QR menu design",
      "café QR menu Jaipur",
      "hotel QR menu Jaipur",
    ],
    category: "Hospitality & Food Tech",
    badge: "Hospitality Suite",
    h1: "Custom QR Menu Design in Jaipur for Restaurants, Cafés & Hospitality",
    subtitle: "Branded, mobile-optimized QR code menus that elevate diner experiences, showcase food photography, and simplify menu navigation.",
    imageUrl: "/assets/menu_qr_service-template.png",
    overview:
      "Diners expect instant, beautiful, and effortless access to menus on their smartphones. WiYou! Tech Studios creates branded QR menu designs in Jaipur for restaurants, cafés, rooftop lounges, and boutique hotels. We replace clumsy, slow-loading PDF downloads with sleek, responsive web menus featuring organized categories, dietary indicators, high-resolution food images, and clear pricing.",
    deliverables: [
      "Custom branded QR codes with your restaurant logo, colors, and print-ready vector files",
      "Mobile-first digital menu layouts optimized for rapid smartphone browsing",
      "Structured food & drink categories (Appetizers, Mains, Specials, Beverages)",
      "High-contrast typography ensuring effortless reading in dim restaurant ambiance",
      "Fast cloud hosting with instant scan-to-view access without requiring app downloads",
      "Integration with table numbers, direct call-to-order, or WhatsApp links where supported",
    ],
    features: [
      {
        title: "No App Download Required",
        description: "Guests simply point their smartphone camera at the table QR code to open the menu instantly in their mobile browser.",
      },
      {
        title: "Clean Brand Integration",
        description: "Your color palette, typography, and restaurant logo are seamlessly integrated across both the physical QR stand and digital menu.",
      },
      {
        title: "Always Up-To-Date",
        description: "Update prices, seasonal specials, or 86'd items digitally without having to reprint expensive paper menus.",
      },
    ],
    faqs: [
      {
        question: "What is a QR menu and how does it work?",
        answer: "A QR menu is a digital menu hosted on the web that diners access by scanning a printed QR code at their table or counter with their smartphone camera. No app download is required.",
      },
      {
        question: "Can I customize the QR menu with our restaurant's branding?",
        answer: "Yes. Every QR menu is designed around your restaurant's unique branding, fonts, colors, logo, and photography to maintain brand consistency.",
      },
      {
        question: "How much does custom QR menu design cost in Jaipur?",
        answer: "Pricing depends on the size of your menu catalog and whether you need digital design only or full web development with dynamic updates. Contact us for a transparent, tailored quote.",
      },
    ],
  },

  "qr-menu-development": {
    slugId: "qr-menu-development",
    title: "QR Menu Development",
    seoTitle: "QR Menu Development Company in Jaipur | WiYou! Tech Studios",
    metaDescription: "WiYou! Tech Studios develops custom, fast-loading QR menu websites and interactive digital menus for restaurants, cafés, and hospitality businesses in Jaipur.",
    primaryKeyword: "QR menu development Jaipur",
    secondaryKeywords: [
      "QR menu development company Jaipur",
      "digital menu development Jaipur",
      "restaurant QR menu development",
      "interactive digital menu development",
      "restaurant menu website Jaipur",
    ],
    category: "Hospitality & Food Tech",
    badge: "Web Applications",
    h1: "Interactive QR Menu Development in Jaipur for Modern Dining Venues",
    subtitle: "High-performance digital menu websites with instant QR access, categorical filtering, real-time item updates, and mobile-first speed.",
    imageUrl: "/assets/menu_qr_service-template.png",
    overview:
      "When diners scan a QR code, they shouldn't wait for a 20MB PDF to download. WiYou! Tech Studios provides dedicated QR menu development in Jaipur, building ultra-fast interactive menu websites designed specifically for smartphones. Our digital menus feature smooth category tabs, search filtering, vegetarian/non-vegetarian badges, and customizable ordering actions.",
    deliverables: [
      "Custom responsive digital menu web app with sub-second loading speed",
      "Dynamic category filtering (Beverages, Starters, Chef's Specials, Desserts)",
      "Dietary filters (Vegetarian, Vegan, Gluten-Free, Spicy ratings)",
      "High-resolution image galleries with optimized WebP compression",
      "Direct call-to-order, table ordering, or WhatsApp inquiry integration where supported",
      "SSL security, high-uptime cloud hosting, and custom domain setup",
    ],
    features: [
      {
        title: "Sub-Second Mobile Performance",
        description: "Engineered with modern web frameworks so menus open instantaneously even on congested café Wi-Fi or mobile data.",
      },
      {
        title: "Intuitive Smartphone Ergonomics",
        description: "Designed for one-thumb scrolling, category jumping, and easy reading in varied restaurant lighting conditions.",
      },
      {
        title: "Dynamic Content Administration",
        description: "Optional cloud admin panel to effortlessly adjust prices, add seasonal dishes, and mark out-of-stock items in real time.",
      },
    ],
    faqs: [
      {
        question: "Can the QR menu include WhatsApp ordering?",
        answer: "Yes! We can configure your digital menu so customers can select items and send their table order directly to your WhatsApp business number with one tap.",
      },
      {
        question: "Will the digital menu work on all mobile phones?",
        answer: "Yes, our digital menus are built with responsive web standards and work seamlessly on all iOS and Android smartphones without requiring any app installations.",
      },
    ],
  },

  "digital-menu": {
    slugId: "digital-menu",
    title: "Digital Restaurant Menus",
    seoTitle: "Digital Menu & Online Restaurant Menu in Jaipur | WiYou! Tech Studios",
    metaDescription: "Transform dining experiences with interactive digital menus in Jaipur by WiYou! Tech Studios. Mobile-friendly, searchable menus for cafés, bars, and hotels.",
    primaryKeyword: "digital menu Jaipur",
    secondaryKeywords: [
      "digital restaurant menu Jaipur",
      "online restaurant menu Jaipur",
      "interactive digital menu",
      "mobile digital menu",
      "digital menu design Jaipur",
    ],
    category: "Hospitality & Food Tech",
    badge: "Digital Products",
    h1: "Digital Restaurant Menus Engineered for Speed, Elegance & Clarity",
    subtitle: "Interactive online menus that make food and drink exploration engaging, accessible, and completely contactless.",
    imageUrl: "/assets/menu_qr_service-template.png",
    overview:
      "A modern digital menu is more than a list of food items—it is a visual showcase that stimulates appetite and enhances customer satisfaction. Based in Jaipur, Rajasthan, WiYou! Tech Studios designs interactive digital menus that help hospitality operators display their culinary offerings with rich descriptions, ingredient highlights, and vivid photography.",
    deliverables: [
      "Interactive multi-category digital menu with seamless navigation",
      "Optimized food photography and visual dish showcases",
      "Allergen and dietary identification badges",
      "Mobile-friendly search bar for quickly finding specific dishes",
      "Multi-language support options where needed",
    ],
    features: [
      {
        title: "Search & Filtering",
        description: "Allows diners to instantly locate their favorite dishes, dietary options, or price ranges in seconds.",
      },
      {
        title: "High-Resolution Showcase",
        description: "Present your culinary signature dishes with vivid, compressed imagery that highlights presentation quality.",
      },
    ],
    faqs: [
      {
        question: "What is the difference between a digital menu and a QR menu?",
        answer: "A digital menu refers to the online, interactive web experience where your food is showcased. A QR menu is the contactless access method (the printed code) that connects diners to that digital menu experience.",
      },
    ],
  },

  "menu-design": {
    slugId: "menu-design",
    title: "Restaurant & Café Menu Design",
    seoTitle: "Restaurant & Café Menu Design in Jaipur | Custom Menus | WiYou!",
    metaDescription: "Expert restaurant menu design in Jaipur by WiYou! Tech Studios. Custom menu card design, food menu layouts, and café branding for hospitality venues.",
    primaryKeyword: "restaurant menu design Jaipur",
    secondaryKeywords: [
      "café menu design Jaipur",
      "menu design Jaipur",
      "food menu design Jaipur",
      "custom menu design Jaipur",
      "restaurant menu card design Jaipur",
      "hospitality menu design Jaipur",
    ],
    category: "Design Architecture",
    badge: "Print & Digital",
    h1: "Professional Restaurant & Café Menu Design in Jaipur",
    subtitle: "Strategic menu engineering, curated typography, and high-impact layouts that increase ticket sizes and reflect culinary excellence.",
    imageUrl: "/assets/menu_qr_service-template.png",
    overview:
      "Menu design is an art and a science known as menu engineering. WiYou! Tech Studios crafts bespoke restaurant and café menus in Jaipur that guide diner attention toward high-margin dishes, highlight culinary craftsmanship, and reinforce your restaurant's interior aesthetic. We deliver print-ready high-resolution files and digital layouts built for screens.",
    deliverables: [
      "Print-ready CMYK vector menu files (Single page, Bi-fold, Tri-fold, or Booklet)",
      "Digital screen versions optimized for RGB displays, websites, and QR menus",
      "Custom typography selection matching your restaurant's interior ambiance",
      "Strategic pricing placement and visual eye-path hierarchy optimization",
      "Full source files in editable Figma / vector formats upon handover",
    ],
    features: [
      {
        title: "Menu Engineering",
        description: "Organizing categories, margins, and visual anchors so your signature and highest-profit dishes receive prime diner attention.",
      },
      {
        title: "Print & Digital Harmony",
        description: "Your physical printed menu cards and online QR menus share cohesive colors, fonts, and brand styling.",
      },
    ],
    faqs: [
      {
        question: "Do you design physical printable menu cards as well as digital?",
        answer: "Yes! We provide print-ready, high-resolution CMYK PDF files with proper bleed and crop marks, alongside digital RGB versions for web and mobile display.",
      },
      {
        question: "Can you design menus for cafés, bars, and rooftop lounges in Jaipur?",
        answer: "Absolutely. We design menus tailored to specific hospitality formats—from coffee shop drink boards to extensive multi-cuisine dining books and cocktail lists.",
      },
    ],
  },

  "restaurant-menu-website": {
    slugId: "restaurant-menu-website",
    title: "Restaurant Menu Websites",
    seoTitle: "Restaurant Menu Website Development in Jaipur | WiYou! Tech Studios",
    metaDescription: "Dedicated restaurant menu website development in Jaipur. Showcase your menu, location, operating hours, and reservations with WiYou! Tech Studios.",
    primaryKeyword: "restaurant menu website Jaipur",
    secondaryKeywords: [
      "restaurant menu website development",
      "custom restaurant menu website",
      "online restaurant menu development",
      "restaurant digital menu website",
    ],
    category: "Hospitality & Food Tech",
    badge: "Web Solutions",
    h1: "Restaurant Menu Website Development in Jaipur",
    subtitle: "Complete digital presence for restaurants, featuring interactive menus, location maps, table reservations, and social integrations.",
    imageUrl: "/assets/menu_qr_service-template.png",
    overview:
      "A complete restaurant website gives diners everything they need: an interactive digital menu, your exact Google Maps location, opening hours, chef stories, and a direct reservation link. WiYou! Tech Studios builds custom restaurant websites in Jaipur that rank for local searches and turn curious foodies into loyal guests.",
    deliverables: [
      "Responsive restaurant website with dedicated menu showcase",
      "Embedded Google Maps, contact details, and opening hours for local SEO",
      "Table reservation request forms or direct WhatsApp booking buttons",
      "Mobile-first QR code integration for on-premise diners",
      "Social media integration (Instagram feed, Google Reviews link)",
    ],
    features: [
      {
        title: "Local Search Optimization",
        description: "Structured with LocalBusiness schema and geo-coordinates so local diners easily find your venue on Google Search and Maps.",
      },
      {
        title: "Seamless Reservation Flow",
        description: "Allow diners to view your menu and reserve their table in one continuous, mobile-friendly experience.",
      },
    ],
    faqs: [
      {
        question: "Can our restaurant menu website include Google Maps and directions?",
        answer: "Yes, we integrate interactive Google Maps, one-tap phone dialing, and address directions to ensure local diners easily find your location.",
      },
    ],
  },

  "web-applications": {
    slugId: "web-applications",
    title: "Custom Web Applications",
    seoTitle: "Custom Web Application Development Company Jaipur | WiYou! Tech Studios",
    metaDescription: "WiYou! Tech Studios builds scalable custom web applications in Jaipur with modern React, Node, cloud databases, authentication, and custom business logic.",
    primaryKeyword: "web application development Jaipur",
    secondaryKeywords: [
      "web app development company",
      "custom web application development",
      "custom web applications",
      "business web applications",
      "software development company Jaipur",
    ],
    category: "Engineering",
    badge: "Cloud & Apps",
    h1: "Custom Web Application Development in Jaipur for Modern Businesses",
    subtitle: "Scalable web applications, customer portals, and internal tools engineered around the way your team and users actually operate.",
    imageUrl: "/assets/projects/4.jpeg",
    overview:
      "When standard off-the-shelf software fails to fit your workflow, custom web applications bridge the gap. Based in Jaipur, WiYou! Tech Studios engineers custom web applications equipped with role-based access control, secure authentication, real-time database synchronization, and scalable cloud APIs.",
    deliverables: [
      "Full-stack web application architecture (React, Node, Firebase, SQL/NoSQL)",
      "Secure user authentication (Email, OAuth, OTP, biometrics)",
      "Role-based access control (Admin, Manager, Staff, Customer tiers)",
      "REST & GraphQL API integrations with third-party software and payment gateways",
      "Automated testing, continuous integration, and secure cloud deployment",
    ],
    features: [
      {
        title: "Tailored to Your Workflow",
        description: "Engineered specifically for your operational requirements rather than forcing you into rigid subscription software.",
      },
      {
        title: "Enterprise-Grade Security",
        description: "Encrypted data in transit and at rest, role-based permissions, and resilient serverless architectures.",
      },
    ],
    faqs: [
      {
        question: "When should a business invest in a custom web application?",
        answer: "When existing SaaS tools no longer fit your operational workflow, when licensing costs become prohibitive, or when you are building a proprietary digital product for your customers.",
      },
    ],
  },

  "dashboard-development": {
    slugId: "dashboard-development",
    title: "Dashboards & Admin Panels",
    seoTitle: "Custom Dashboard & Admin Panel Development | WiYou! Tech Studios",
    metaDescription: "Develop custom analytics dashboards, internal management tools, and administrative panels in Jaipur with WiYou! Tech Studios.",
    primaryKeyword: "dashboard development Jaipur",
    secondaryKeywords: [
      "custom dashboard development",
      "admin dashboard development",
      "admin panel development company",
      "analytics dashboard development",
    ],
    category: "Engineering",
    badge: "Enterprise Tools",
    h1: "Custom Dashboard & Admin Panel Development in Jaipur",
    subtitle: "Clean data visualizations, real-time metrics, user management, and operational controls in one intuitive interface.",
    imageUrl: "/assets/projects/5.jpeg",
    overview:
      "Transforming complex raw data into clear, actionable business insights requires deliberate interface design and robust database engineering. WiYou! Tech Studios builds custom administrative dashboards and operational panels for businesses in Jaipur and across India.",
    deliverables: [
      "Interactive data visualization charts, graphs, and metric summary cards",
      "User and role management interfaces with detailed permission matrices",
      "CSV, Excel, and PDF reporting export capabilities",
      "Real-time data feeds, event streaming, and audit activity logs",
    ],
    features: [
      {
        title: "Actionable Visuals",
        description: "Clean charts and KPIs that allow decision-makers to comprehend business metrics at a glance.",
      },
    ],
    faqs: [
      {
        question: "Can the dashboard connect to our existing database or APIs?",
        answer: "Yes. We regularly connect custom dashboards to existing Firestore, PostgreSQL, MySQL, REST APIs, or third-party webhooks.",
      },
    ],
  },

  "ecommerce-development": {
    slugId: "ecommerce-development",
    title: "E-commerce Website Development",
    seoTitle: "Ecommerce Website Development Company in Jaipur | WiYou! Tech Studios",
    metaDescription: "Build high-converting online stores with WiYou! Tech Studios in Jaipur. Custom e-commerce website development with secure payment gateways and fast checkout.",
    primaryKeyword: "ecommerce website development Jaipur",
    secondaryKeywords: [
      "ecommerce website development company",
      "online store development Jaipur",
      "custom ecommerce website",
      "ecommerce web design Jaipur",
    ],
    category: "Engineering",
    badge: "Commerce",
    h1: "Ecommerce Website Development Company in Jaipur Built for Sales",
    subtitle: "Custom online storefronts with seamless product navigation, frictionless checkout flows, and secure payment integrations.",
    imageUrl: "/assets/projects/6.jpeg",
    overview:
      "In e-commerce, every 100 milliseconds of latency directly reduces conversion rates. As a premier e-commerce website development company in Jaipur, WiYou! Tech Studios designs and builds fast, secure online shopping experiences with intuitive product categorization, dynamic inventory, and multi-gateway payment processing.",
    deliverables: [
      "Custom product catalog with filtering, variants, and search",
      "Frictionless mobile shopping cart and checkout optimization",
      "Payment gateway integrations (Razorpay, Stripe, Cashfree, UPI, Net Banking)",
      "Automated order confirmation emails and SMS notification hooks",
    ],
    features: [
      {
        title: "Conversion-Tuned Checkout",
        description: "Streamlined single-page or two-step checkout designed to minimize cart abandonment on smartphones.",
      },
    ],
    faqs: [
      {
        question: "Which payment gateways do you support for Indian e-commerce?",
        answer: "We integrate Razorpay, Cashfree, Stripe, PayU, and direct UPI QR payments, allowing customers to pay with cards, net banking, and UPI apps.",
      },
    ],
  },

  "seo-services": {
    slugId: "seo-services",
    title: "Technical & Local SEO Services",
    seoTitle: "SEO Services & SEO Company in Jaipur | Technical SEO | WiYou!",
    metaDescription: "Boost your organic visibility with technical SEO services in Jaipur by WiYou! Tech Studios. Structured data, Core Web Vitals, local SEO, and on-page optimization.",
    primaryKeyword: "SEO services Jaipur",
    secondaryKeywords: [
      "SEO company Jaipur",
      "technical SEO Jaipur",
      "local SEO Jaipur",
      "website SEO services",
      "SEO agency Jaipur",
    ],
    category: "Growth & Strategy",
    badge: "Organic Search",
    h1: "Technical & Local SEO Services in Jaipur for Sustainable Search Growth",
    subtitle: "Performance optimization, Schema.org structured data, Core Web Vitals tuning, and local search dominance for modern brands.",
    imageUrl: "/assets/projects/1.jpeg",
    overview:
      "True SEO is rooted in technical excellence, high-quality information architecture, and authentic search intent satisfaction. At WiYou! Tech Studios in Jaipur, we do not use black-hat tricks or promise fake overnight rankings. We audit and rebuild your website's technical foundations, Core Web Vitals, structured data, and on-page copy so Google and your customers find exactly what they are searching for.",
    deliverables: [
      "Core Web Vitals remediation (LCP, INP, CLS optimization)",
      "Schema.org JSON-LD structured data implementation (Organization, LocalBusiness, FAQ)",
      "Local SEO optimization for Jaipur, Rajasthan search rankings",
      "XML sitemap creation, canonical audit, and robots.txt configuration",
      "Keyword mapping and on-page semantic copywriting",
    ],
    features: [
      {
        title: "Technical Precision",
        description: "Fixing crawl errors, redirect chains, slow asset loading, and mobile rendering bottlenecks.",
      },
    ],
    faqs: [
      {
        question: "Do you guarantee #1 rankings on Google?",
        answer: "No reputable agency can guarantee #1 rankings because Google's algorithm is independent. We focus on proven technical optimization, content depth, speed, and local relevance to give you the highest possible organic search advantage.",
      },
    ],
  },

  "website-maintenance": {
    slugId: "website-maintenance",
    title: "Website Maintenance & Support",
    seoTitle: "Website Maintenance & Support Services in Jaipur | WiYou! Tech Studios",
    metaDescription: "Reliable website maintenance services in Jaipur by WiYou! Tech Studios. Security updates, cloud backups, bug fixes, and continuous performance tuning.",
    primaryKeyword: "website maintenance Jaipur",
    secondaryKeywords: [
      "website maintenance services",
      "website support services",
      "website management Jaipur",
      "website security maintenance",
    ],
    category: "Engineering",
    badge: "Support",
    h1: "Website Maintenance & Ongoing Support Services in Jaipur",
    subtitle: "Keep your digital platform secure, fast, and continuously updated with dedicated technical maintenance.",
    imageUrl: "/assets/projects/2.jpeg",
    overview:
      "A website is an active digital asset that requires regular maintenance, security monitoring, and technical care. WiYou! Tech Studios provides website maintenance services in Jaipur so you can focus on running your business while we ensure your website runs at peak performance 24/7.",
    deliverables: [
      "Regular dependency, security patch, and CMS updates",
      "Automated cloud backups and instant disaster recovery protocol",
      "Continuous uptime monitoring and SSL certificate management",
      "Priority bug resolution and content updates",
    ],
    features: [
      {
        title: "Peace of Mind",
        description: "Experienced engineers actively monitoring and maintaining your site's health and security around the clock.",
      },
    ],
    faqs: [
      {
        question: "Can you maintain a website built by another agency?",
        answer: "Yes, we can conduct a technical code audit of your existing site and transition it into one of our monthly maintenance and support plans.",
      },
    ],
  },

  "landing-page-development": {
    slugId: "landing-page-development",
    title: "Landing Page Development",
    seoTitle: "High-Converting Landing Page Design & Development Jaipur | WiYou!",
    metaDescription: "Turn traffic into customers with landing page development in Jaipur by WiYou! Tech Studios. Fast-loading, conversion-focused landing pages.",
    primaryKeyword: "landing page development Jaipur",
    secondaryKeywords: [
      "landing page design Jaipur",
      "high converting landing page",
      "business landing page",
      "campaign landing page",
    ],
    category: "Engineering",
    badge: "Conversion",
    h1: "High-Converting Landing Page Development in Jaipur",
    subtitle: "Laser-focused landing pages engineered for paid ad campaigns, product launches, and lead capture.",
    imageUrl: "/assets/projects/3.jpeg",
    overview:
      "When running Google Ads or marketing campaigns, driving traffic to a generic homepage wastes valuable ad budget. WiYou! Tech Studios engineers standalone, lightning-fast landing pages in Jaipur designed with a single, clear objective: converting visitors into paying inquiries and customers.",
    deliverables: [
      "Single-purpose, high-converting layout structure",
      "Sub-second page load times maximizing Google Ads Quality Scores",
      "Direct form integration with email alerts, Google Sheets, or CRM webhooks",
      "Mobile-optimized click-to-call and WhatsApp action buttons",
    ],
    features: [
      {
        title: "Maximum Ad ROI",
        description: "Fast loading pages that improve ad quality scores, lower cost-per-click, and maximize lead conversion.",
      },
    ],
    faqs: [
      {
        question: "How fast can you deliver a custom campaign landing page?",
        answer: "Most landing page projects are designed, coded, and deployed live within 3 to 7 business days.",
      },
    ],
  },

  "pwa-development": {
    slugId: "pwa-development",
    title: "Progressive Web Apps (PWA)",
    seoTitle: "Progressive Web App (PWA) Development Company | WiYou! Tech Studios",
    metaDescription: "Build installable Progressive Web Apps (PWA) in Jaipur with WiYou! Tech Studios. Offline support, push notifications, and native app speeds on the web.",
    primaryKeyword: "PWA development Jaipur",
    secondaryKeywords: [
      "progressive web app development",
      "PWA development company",
      "installable web apps",
    ],
    category: "Engineering",
    badge: "Mobile Web",
    h1: "Progressive Web App (PWA) Development in Jaipur",
    subtitle: "Installable web applications with offline capabilities, push notifications, and near-instant load times without app store friction.",
    imageUrl: "/assets/projects/4.jpeg",
    overview:
      "Progressive Web Apps combine the universal reach of the open web with the tactile responsiveness of native mobile apps. At WiYou! Tech Studios in Jaipur, we build PWAs that users can install directly to their phone's home screen with zero app store downloads.",
    deliverables: [
      "PWA Web App Manifest and Service Worker caching strategies",
      "Offline browsing mode and resilient network fallbacks",
      "Home screen install prompts for iOS and Android",
      "Web push notification integration where applicable",
    ],
    features: [
      {
        title: "Zero App Store Friction",
        description: "Bypass app store submission delays and fees while delivering an app-like icon and experience on your customer's phone.",
      },
    ],
    faqs: [
      {
        question: "Can a PWA work on both iPhones and Android phones?",
        answer: "Yes, PWAs run on all modern mobile web browsers including Safari on iOS and Chrome on Android.",
      },
    ],
  },
};
